module.exports = __webpack_public_path__ + "/images/3b6ff68c19b4d71c914bf68c1b21ff8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app/logo.png
// module id = 591
// module chunks = 0